// extracted by mini-css-extract-plugin
module.exports = {"botoPaginacio":"llistatfirmes_botoPaginacio__dTLnM"};